<div class="flex-fill d-flex flex-column" style="max-width: 600px">
    <div *ngIf="!dealerEntry">
        <h3>This dealer entry link has expired</h3>
    </div>
    <div class="m-1 d-flex justify-content-center">
        <button class="btn btn-success portal-buttons" (click)="openNewDealerPdf()">Download Form as PDF</button>
    </div>

    <div class="grid-fill m-3" *ngIf="dealerEntry">
        <dx-form [formData]="dealerEntry" [colCount]="1" [validationGroup]="validationGroup" [readOnly]="dealerEntry.submitted">
            <dxi-item itemType="group" caption="Company Information">
                <dxi-item dataField="companyName">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="contactName"></dxi-item>
                <dxi-item dataField="website"></dxi-item>

                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item dataField="resaleNumber" [label]="{ text: 'EIN' }" [editorOptions]="{ width: '150px' }"></dxi-item>
                </dxi-item>

                <dxi-item dataField="email" [label]="{ text: 'Sales Email' }"></dxi-item>
                <dxi-item dataField="apEmail" [label]="{ text: 'AP Email' }"></dxi-item>

                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item dataField="phone1" [label]="{ text: 'Phone' }"></dxi-item>
                    <!-- <dxi-item dataField="phone2"></dxi-item> -->
                </dxi-item>
                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item dataField="fax"></dxi-item>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Billing Address Details">
                <dxi-item dataField="billAddress1" [label]="{ text: 'Address 1' }"></dxi-item>
                <dxi-item dataField="billAddress2" [label]="{ text: 'Address 2' }"></dxi-item>
                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item dataField="billCity" [label]="{ text: 'City' }"></dxi-item>
                    <dxi-item dataField="billState" [label]="{ text: 'State' }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item dataField="billZip" [label]="{ text: 'ZIP' }"></dxi-item>
                    <dxi-item dataField="billCountry" [label]="{ text: 'Country' }"></dxi-item>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Tax Exemption Forms">
                <dxi-item>
                    <div *dxTemplate class="d-flex flex-column">
                        <ng-container *ngFor="let exemption of stateTaxExemptions">
                            <a [routerLink]="[]" (click)="openStateTaxExemption(exemption)">{{ exemption.name }}</a>
                        </ng-container>
                    </div>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Attachments">
                <dxi-item>
                    <div *dxTemplate>
                        <ul style="list-style-type: none; padding-inline-start: 0px" *ngIf="attachments">
                            <li *ngFor="let attachment of attachments">
                                <a *ngIf="!dealerEntry.submitted" title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a
                                >&nbsp;
                                <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                            </li>
                        </ul>
                    </div>
                </dxi-item>
                <dxi-item>
                    <div *dxTemplate>
                        <dx-file-uploader
                            name="fileUpload"
                            selectButtonText="Select Pdf(s)"
                            class="attachments attachments-border"
                            [ngClass]="{ 'attachments-border-required': !areAttachmentsValid }"
                            accept=".pdf"
                            [allowedFileExtensions]="['.pdf']"
                            uploadMode="instantly"
                            [showFileList]="false"
                            [multiple]="true"
                            [uploadUrl]="uploadUrl"
                            [uploadHeaders]="uploadHeader"
                            [readOnly]="dealerEntry.submitted"
                            (onValueChanged)="uploadValueChanged($event)"
                            (onUploadStarted)="uploadStarted($event)"
                            (onUploadError)="uploadError($event)"
                            (onUploaded)="uploaded($event)"
                        >
                        </dx-file-uploader>
                    </div>
                </dxi-item>
                <dxi-item>
                    <div *dxTemplate class="d-flex">
                        <!-- <button class="btn btn-success me-3" (click)="openNewDealerPdf()">Download Form as Pdf</button> -->
                        <!-- <button class="btn btn-danger" (click)="submit()" [disabled]="dealerEntry.submitted">Submit</button> -->
                        <!-- <h3 class="ms-2" *ngIf="dealerEntry.submitted">The dealer form has been submitted!</h3> -->
                    </div>
                </dxi-item>
            </dxi-item>
        </dx-form>
        <div class="m-1 d-flex justify-content-center">
            <button class="btn btn-danger portal-buttons" (click)="submit()" [disabled]="dealerEntry.submitted">Submit</button>
            <!-- <button class="btn btn-success me-3 download-pdf-button" (click)="openNewDealerPdf()">Download Form as PDF</button> -->
        </div>
        <div>
            <h2 class="d-flex mt-2 justify-content-center" *ngIf="dealerEntry.submitted"><strong>Submitted</strong></h2>
            <h3 class="d-flex mt-2 justify-content-center" *ngIf="dealerEntry.submitted"><strong>{{dealerEntry.submitted | date: 'MM/dd/yyyy hh:mm:ss a'}}</strong></h3>

        </div>
    </div>
</div>
